<app-pan-card
  [isPageContainer]="true"
  pageContainerSize="xl"
  [header]="'LP Manage Queues'"
  subheader="This page has been moved to the new LP App"
>
  <div class="flex justify-center p-4">
    <a
      panButton
      color="primary"
      icon="open_in_new"
      [href]="manageQueuesUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      Open LP Manage Queues
    </a>
  </div>
</app-pan-card>
